import { ExEmptyState } from '@boomi/exosphere';
import styles from './Unauthorized.module.css';
import { FABRIC_BASE_URL } from '../config';

const Unauthorized = () => (
    <div className={styles.container}>
        <ExEmptyState
            label="Access Required"
            text="You don't have the necessary privilege for Boomi Connect. Contact your admin to request access."
        >
            <div slot="header">
                <img src={`${FABRIC_BASE_URL}/emptyStateIcon.svg`} alt="Access Required" />
            </div>
        </ExEmptyState>
    </div>
);

export default Unauthorized;
